var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45476 12.4794L7.45257 12.4773C7.38807 12.4138 7.33718 12.3385 7.30254 12.2559C7.26791 12.1734 7.25015 12.0851 7.25015 11.996C7.25015 11.9069 7.26791 11.8186 7.30254 11.7361C7.33718 11.6535 7.38807 11.5783 7.45257 11.5147L7.45476 11.5126L13.5614 5.4495C13.5617 5.44919 13.562 5.44889 13.5623 5.44858C13.6265 5.38568 13.7027 5.33562 13.7868 5.30149C13.8714 5.2672 13.9621 5.24975 14.0538 5.25027L14.0538 5.25032L14.0624 5.25027C14.1541 5.24975 14.2448 5.2672 14.3294 5.30149C14.4131 5.33545 14.489 5.38518 14.5529 5.44764C14.6798 5.57535 14.75 5.74644 14.75 5.92362C14.75 6.10136 14.6793 6.27297 14.5517 6.40081C14.5515 6.40103 14.5513 6.40125 14.551 6.40147L9.45233 11.4638L8.91629 11.996L9.45233 12.5282L14.551 17.5905C14.5513 17.5908 14.5515 17.591 14.5517 17.5912C14.6793 17.719 14.75 17.8906 14.75 18.0684C14.75 18.2464 14.6791 18.4183 14.551 18.5462L14.5504 18.5468C14.4865 18.6109 14.4101 18.662 14.3255 18.697C14.2409 18.7319 14.15 18.75 14.0581 18.75C13.9662 18.75 13.8753 18.7319 13.7907 18.697C13.7061 18.662 13.6297 18.6109 13.5658 18.5468L13.5658 18.5468L13.5636 18.5447L7.45476 12.4794Z",
    fill: "black",
    stroke: "currentColor",
    strokeWidth: 1.49997
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/goBack.0c8d3808cbf7ec52f5bd57d9e1e2f3b0.svg";
export { ForwardRef as ReactComponent };